import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function FAQ() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <section id="faq" data-testid="faq-section" className="py-24 px-6 max-w-4xl mx-auto border-t border-white/10">
      <div className="text-center mb-12">
        <span className="mono-lbl text-xs text-[#a4133c] tracking-[0.2em] uppercase">{t.faq.label}</span>
        <h2 className="serif-disp text-4xl md:text-5xl font-light mt-2">{t.faq.title}</h2>
      </div>

      <div className="space-y-4">
        {t.faq.items.map((item, i) => (
          <details
            key={item.q}
            data-testid={`faq-item-${i}`}
            className="group border border-white/10 rounded-xl bg-white/[0.02] px-6 py-5 open:border-[#a4133c]/50 transition-colors"
          >
            <summary className="cursor-pointer list-none flex justify-between items-center gap-4">
              <span className="serif-disp text-lg md:text-xl text-white font-light">{item.q}</span>
              <span className="text-[#c9933b] text-xl leading-none transition-transform duration-300 group-open:rotate-45">+</span>
            </summary>
            <p className="text-neutral-400 text-sm font-light leading-relaxed mt-4">{item.a}</p>
          </details>
        ))}
      </div>

      <div
        data-testid="payment-card"
        className="mt-10 border border-[#c9933b]/35 bg-gradient-to-br from-[#c9933b]/12 to-transparent rounded-2xl px-8 py-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6"
      >
        <div>
          <span className="mono-lbl text-xs uppercase tracking-widest text-[#c9933b]">{t.faq.payLabel}</span>
          <p className="text-neutral-300 text-sm font-light leading-relaxed mt-2 max-w-lg">{t.faq.payText}</p>
        </div>
        <a
          data-testid="venmo-link"
          href="https://venmo.com/u/MahoganyD"
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 px-6 py-3.5 bg-[#008CFF] hover:opacity-90 text-white text-xs uppercase tracking-widest font-semibold rounded-lg transition-all"
        >
          {t.faq.venmoBtn}
        </a>
      </div>
    </section>
  );
}
